var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isArray, isNilOrEmpty, only, removeKeys } from '@pcty/utils';
export var handleOnChange = function (_a) {
    var option = _a.option, id = _a.id, isMulti = _a.isMulti, fixedOptions = _a.fixedOptions, getValidation = _a.getValidation, setValidation = _a.setValidation, onChange = _a.onChange, userManagedValidation = _a.userManagedValidation, updateForm = _a.updateForm, formInputId = _a.formInputId, label = _a.label, isLoaded = _a.isLoaded, options = _a.options;
    if (isNilOrEmpty(option) || option === undefined) {
        var event_1 = {
            id: id,
            item: isMulti ? __spreadArray([], fixedOptions, true) : undefined,
        };
        var validation_1 = getValidation(event_1.item);
        setValidation(only(validation_1, ['valid', 'errorMessage']));
        onChange === null || onChange === void 0 ? void 0 : onChange(event_1);
        if (!userManagedValidation) {
            updateForm(formInputId, __assign(__assign({}, validation_1), { value: event_1.item, id: id, label: label, dirty: true }));
        }
        return;
    }
    if (!isMulti) {
        var event_2 = {
            id: id,
            item: removeKeys(option, ['optionsIndex', 'selected']),
        };
        var validation_2 = getValidation(event_2.item);
        setValidation(only(validation_2, ['valid', 'errorMessage']));
        onChange === null || onChange === void 0 ? void 0 : onChange(event_2);
        if (!userManagedValidation) {
            updateForm(formInputId, __assign(__assign({}, validation_2), { value: event_2.item, id: id, label: label, dirty: true }));
        }
        return;
    }
    var item = Array.from(new Set(__spreadArray(__spreadArray([], fixedOptions, true), (isArray(option) ? option : [option]), true)));
    var newEventItems = [];
    for (var i = 0; i < item.length; i++) {
        newEventItems.push(removeKeys(item[i], ['optionsIndex', 'selected']));
    }
    // make sure we dont send out the header or any disabled items
    newEventItems = newEventItems.filter(function (x) { return x && !x.header && !x.disabled && !x.creatable && !x.empty; });
    // CDS-3057: Fixing an issue where default items were not able to be removed by checking if there are any items being passed on initial render (when isLoaded is false)
    if (!isLoaded && isNilOrEmpty(options))
        return;
    var event = {
        id: id,
        item: newEventItems,
    };
    var validation = getValidation(event.item);
    setValidation(only(validation, ['valid', 'errorMessage']));
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    if (!userManagedValidation) {
        updateForm(formInputId, __assign(__assign({}, validation), { value: event.item, id: id, label: label, dirty: true }));
    }
};
